import { render, staticRenderFns } from "./ExternalLinkV2.vue?vue&type=template&id=6fef312e&"
import script from "./ExternalLinkV2.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports